import { Injectable, inject } from '@angular/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';

// Injectable replacement for the static GlobalMessageUtil: it resolves PrimeNG's MessageService through DI,
// so toasts always reach the <p-toast key="main"> in app.component.html without an init() call.
@Injectable({ providedIn: 'root' })
export class ToastService {
  private static readonly DEFAULT_KEY = 'main';
  private static readonly DEFAULT_LIFE = 3000;

  private readonly messageService = inject(MessageService);

  error(summary: string, detail: string, life = ToastService.DEFAULT_LIFE, key = ToastService.DEFAULT_KEY): void {
    this.add({ severity: 'error', summary, detail, life, key });
  }

  warn(summary: string, detail: string, life = ToastService.DEFAULT_LIFE, key = ToastService.DEFAULT_KEY): void {
    this.add({ severity: 'warn', summary, detail, life, key });
  }

  success(summary: string, detail: string, life = ToastService.DEFAULT_LIFE, key = ToastService.DEFAULT_KEY): void {
    this.add({ severity: 'success', summary, detail, life, key });
  }

  info(summary: string, detail: string, life = ToastService.DEFAULT_LIFE, key = ToastService.DEFAULT_KEY): void {
    this.add({ severity: 'info', summary, detail, life, key });
  }

  clear(key?: string): void {
    this.messageService.clear(key);
  }

  private add(message: ToastMessageOptions): void {
    this.messageService.add(message);
  }
}
